/**
 * Copyright (c) 2023-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { type ReactNode, createContext, useContext } from "react";
import type { LtiData } from "../interfaces";

interface LtiContextType {
  ltiData?: LtiData;
}

const LtiContext = createContext<LtiContextType | undefined>(undefined);

interface Props {
  ltiData?: LtiData;
  children: ReactNode;
}

export const LtiContextProvider = ({ ltiData, children }: Props) => (
  <LtiContext value={{ ltiData }}>{children}</LtiContext>
);

export const useLtiData = () => {
  const context = useContext(LtiContext);
  return context;
};
